import { BASE_API_URL } from '@config/environment';
import { errorLogHandler } from '@shared/errorLogHandler';
import { UploadResult } from '@shared/types';
import axios, { CancelTokenSource } from 'axios';

export async function imageUpload(
  file: File,
  processObjectId: string,
  mediaType: string,
  cancelToken: CancelTokenSource,
  visible: boolean
): Promise<UploadResult> {
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('media_type', mediaType); // must be snake_case
    formData.append('visible', visible.toString());

    const response = await axios.post(
      `${BASE_API_URL}/process_object/${processObjectId}/image/upload`,
      formData,
      {
        cancelToken: cancelToken.token,
        headers: { 'Content-Type': 'multipart/form-data' },
      }
    );

    return {
      status: 'SUCCESS',
      image: response.data.image,
    };
  } catch (error: Error | unknown) {
    errorLogHandler(error);
    if (axios.isCancel(error)) {
      console.log('Request canceled', error.message);

      return {
        status: 'CANCELED',
        name: file.name,
      };
    }

    if (!(error instanceof Error)) {
      return {
        status: 'FAILED',
        name: file.name,
        size: file.size,
        type: file.type,
        error: new Error('Unknown error'),
      };
    }

    return {
      status: 'FAILED',
      name: file.name,
      size: file.size,
      type: file.type,
      error,
    };
  }
}
